import '../public/style/theme/index.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import { IDEProgram } from './libs/com/MetaPattern/Product/IDE/IDEProgram';

Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small' });

// IDE程序初始化操作
IDEProgram.instance.initAsync().then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app');
});
